import { Box, Typography } from '@mui/material';
import React from "react";
import { CircularProgressBar, ArcCircularGauge } from "./utils/CircularProgressBar.tsx";
import { WhiteCircleInfo } from "./utils/WhiteCircleInfo.tsx";
import {GaugeType} from "types/dashboard.ts";

interface DashboardCardInfoProps {
    background?: boolean;
    gaugeType?: GaugeType;
    title: string;
    value: string | undefined;
}

export const DashboardCardInfo: React.FC<DashboardCardInfoProps> = ({ background = false, gaugeType = GaugeType.None, title, value }) => {
    const result = value === undefined  ? '- - -' : value

    return (
        <Box
            sx={{
                width: '100%',
                height: '100%',
                borderRadius: '5px',
                background: background ? 'linear-gradient(to top, #003936, #39C610, #D1FFC7)' : 'transparent',
                display: 'flex',
                flexDirection: "column",
                alignItems: 'center',
                position: 'relative',
            }}
        >
            {background && gaugeType === GaugeType.Chrono && (
                <>
                    <Box sx={{ pt: '14.5%', position: 'absolute' }}>
                        <CircularProgressBar />
                    </Box>
                    <WhiteCircleInfo value={result} background={background} gaugeType={gaugeType} />
                </>
            )}

            {background && gaugeType === GaugeType.Gauge && (
                <>
                    <Box sx={{ pt: '14.5%', position: 'absolute' }}>
                        <ArcCircularGauge />
                    </Box>
                    <WhiteCircleInfo value={result} background={background} gaugeType={gaugeType} />
                </>
            )}

            {gaugeType === GaugeType.None && (
                <WhiteCircleInfo value={result} background={background} gaugeType={gaugeType} />
            )}

            <Typography
                variant="titleSmall"
                sx={{
                    mt:5,
                    ml:1,
                    mr:1,
                    fontSize: '11px',
                    color: background ? 'white' : 'palette.grey.100',
                    textAlign: 'center',
                }}
            >
                {title}
            </Typography>
        </Box>
    );
};